import diff from '../helpers/array-diff'

module.exports = function() {
      return diff(this.templatesKeys, this.Columns);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/computed/custom-columns.js